module.exports = __webpack_public_path__ + "static/media/mic-off.b77454c3.svg";